module.exports = __webpack_public_path__ + "static/simple-column-b3a714930a87565227d09358c5fdb418.png";